import {
    FieldInCard,
} from 'app/types/form.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LoggerFormData,
    LoggerValue,
} from './LoggerForm.types'

type LoggerFormField = FieldInCard<keyof LoggerFormData>

const fields = ({
    loadOptions,
    loadLabel,
    value: {
        positionConfiguration,
    },
    loggerLabels,
    l,
}: {
    loadOptions: any,
    loadLabel: any,
    value: LoggerValue,
    loggerLabels: any,
    l: (key: string) => string,
}): LoggerFormField[] => {
    const allowedLoggerPositionValues = positionConfiguration
        ? positionConfiguration.reduce((acc, name) => {
            return {
                ...acc,
                [name]: loggerLabels[name] || name,
            }
        }, {}) : {}

    return [{
        id: 'logger',
        fields: [
            {
                label: 'Logger',
                componentName: 'TypeaheadObjectContainer',
                labelKey: 'LOGGER',
                name: 'logger',
                className: 'internalLogger',
                loadLabel,
                loadOptions,
                labelField: 'loggerNumber',
                required: true,
            },
            {
                name: 'isDefaultLogger',
                className: 'isDefaultLogger',
                labelKey: 'DEFAULT_LOGGER',
                componentName: 'Checkbox',
            },
            {
                name: 'exchangeDocumentations',
                labelKey: 'EXCHANGE_DOCUMENTATIONS',
                className: 'exchangeDocumentations',
                componentName: 'AttachmentsObjectSelector',
            },
            {
                name: 'exchangeTimestamp',
                className: 'exchangeTimestamp',
                componentName: 'DateTimeZonedSelect',
                required: true,
                labelKey: 'EXCHANGE_TIMESTAMP',
            },
            {
                name: 'removedOn',
                componentName: 'DateTimeZonedSelect',
                labelKey: 'REMOVED_ON',
            },
            {
                name: 'loggerPositionConfiguration',
                required: true,
                useDropdown: true,
                componentName: 'EnumSelector',
                allowedValues: allowedLoggerPositionValues,
                labelKey: 'LOGGER_CONFIGURATION',
            },
            {
                name: 'exchangeComment',
                className: 'exchangeComment',
                componentName: 'LongText',
                rows: 5,
                labelKey: 'EXCHANGE_COMMENT',
            },
            {
                name: 'linkToCreate',
                componentName: 'SkyNetLink',
                link: '/apps/loggers/all/create',
                text: l('LOGGER_MISSING?_ADD_HERE'),
                type: TypeLink.INTERNAL_WITH_ICON,
                size: SizeLink.S,
                labelKey: ' ',
            },
        ],
    }]
}

export default fields
